export default __webpack_public_path__ + "0f973b3ef44bc194333d2ef7350c24c2.png";